import React from 'react';
import { Tooltip } from '../Tooltip';

interface StatusPillProps {
  variant?: 'yellow' | 'gray';
  label: string;
  icon?: React.ReactNode;
  tooltip?: React.ReactNode;
  tooltipAlign?: 'left' | 'center' | 'right' | 'top';
}

const VARIANT_CLASSES = {
  yellow: 'border-yellow-tag-border bg-yellow-tag-bg text-yellow-tag-text',
  gray: 'border-[#B0B1B1] bg-gray-50 text-gray-675',
};

export const StatusPill: React.FC<StatusPillProps> = ({
  variant = 'yellow',
  label,
  icon,
  tooltip,
  tooltipAlign,
}) => {
  const pill = (
    <div
      className={`inline-flex items-center gap-50 px-90 py-25 border rounded-full ${VARIANT_CLASSES[variant]}`}
    >
      {icon && <span className="flex-shrink-0">{icon}</span>}
      <span className="text-sm font-bold">{label}</span>
    </div>
  );

  if (tooltip) {
    return (
      <Tooltip content={tooltip} align={tooltipAlign}>
        {pill}
      </Tooltip>
    );
  }

  return pill;
};
